import ScheduleModel from "../api/models/ScheduleModel";
import SessionModel from "../api/models/SessionModel";
import SizedStack from "../helpers/SizedStack";
import CalendarScheduleSlotModel from "../models/CalendarScheduleSlotModel";
import { ActiveSessionsService } from "./activeSessionsService";

export class StudentScheduleService extends ActiveSessionsService {
  constructor(sessions: SessionModel[], schedule: ScheduleModel) {
    const calendarSlots =
      schedule?.slots?.map((slot) => new CalendarScheduleSlotModel(slot)) || [];
    super(sessions, calendarSlots);
  }

  generateActiveSessions(sessionsCount = 3): SessionModel[] {
    let stack = new SizedStack<SessionModel>(sessionsCount);
    stack.push(...this.sessions.slice(-1 * sessionsCount));
    stack.push(...this.scheduleSlotsSessions.slice(0, sessionsCount - 1));
    stack.pushIfAvailable(
      ...this.scheduleSlotsSessions.slice(sessionsCount - 1, sessionsCount)
    );

    return stack.asList;
  }
}
